import {createRoutine, Routine} from 'redux-saga-routines';
import {Action, ActionFunctionAny} from "redux-actions";

// Transactions
export const getTransactions: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/GET_TRANSACTIONS'
);

export const getDevice: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/GET_DEVICE'
);

export const evaluatePosition: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/EVALUATE_POSITION'
);

export const pollTransactions: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/POLL_TRANSACTIONS'
);

export const getNotificationEvents: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/NOTIFICATION_EVENTS'
);

export const alarmAnalysis: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/ALARM_ANALYSIS'
);

export const getBatteryForRange: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/GET_BATTERY_FOR_RANGE'
);
export const getSignalForRange: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/GET_SIGNAL_FOR_RANGE'
);
export const logTxLogAccess: Routine<ActionFunctionAny<Action<any>>> = createRoutine(
  '@@TransactionLog/LOG_TX_LOG_ACCESS'
);
